/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PartnerConnectionDto } from './partnerConnectionDto';
import { EnterpriseIdDto } from './enterpriseIdDto';

export interface EnterpriseConfigV2Dto {
  activePartnerConnections?: Array<PartnerConnectionDto>;
  currency?: string;
  email?: string;
  fuelCostPerL?: number;
  language?: string;
  owner?: EnterpriseIdDto;
  seasonStartMonth?: string;
  seasonStartYear?: number;
  timezone?: string;
}
